import React, { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks'
import { selectAccountId } from '../../../../../../store/auth/authSlice'
import { usePollingEffect } from '../../../common/hooks/usePollingEffect'
import {
  selectClientProfileResultPollingEnabled,
  setClientProfileResults,
  addClientProfileResultsPollCounter,
} from '../../../../../../store/meetingSummary/clientProfile'
import { useLazyGetScorecardResultsByFilterQuery } from '../../../../../../store/ai/scorecard'

export const ClientProfilePoller: React.FC = () => {
  const { roomId = '', sessionId = '' } = useParams()
  const accountId = useAppSelector(selectAccountId)

  usePollClientProfile(accountId, roomId, sessionId)
  return null
}

const usePollClientProfile = (accountId: string, roomId: string, sessionId: string) => {
  const dispatch = useAppDispatch()

  const clientProfileResultPollingEnabled = useAppSelector(selectClientProfileResultPollingEnabled)
  const [triggerGetScorecardResults] = useLazyGetScorecardResultsByFilterQuery()

  const getClientProfileResults = useCallback(async () => {
    const clientProfileResults = await triggerGetScorecardResults(
      {
        accountId,
        body: {
          source: {
            type: 'meeting',
            roomId: roomId,
            sessionId: sessionId,
          },
        },
      },
      false,
    ).unwrap()
    if (clientProfileResults.length) {
      dispatch(setClientProfileResults(clientProfileResults))
    }
    dispatch(addClientProfileResultsPollCounter())
  }, [dispatch, accountId, roomId, sessionId, triggerGetScorecardResults])

  const { start: startClientProfilePolling, stop: stopClientProfilePolling } = usePollingEffect(getClientProfileResults, [], {
    interval: 3000,
  })

  useEffect(() => {
    if (clientProfileResultPollingEnabled) {
      startClientProfilePolling()
    } else {
      stopClientProfilePolling()
    }
  }, [clientProfileResultPollingEnabled, startClientProfilePolling, stopClientProfilePolling])
}
